import React from 'react';

import { FAQs } from '../utils/Data.js';
import CategoryQues from './CategoryQues.js';

const FAQ = ({ setPrompt }) => {
  return (
    <div className="flex gap-2 w-full py-2">
      {FAQs.map((category) => {
        return (
          <CategoryQues
            key={category.title}
            data={category}
            handleClick={setPrompt}
          />
        );
      })}
    </div>
  );
};

export default FAQ;
